import { Maybe } from "src/generated/graphqlTypes";
import { ObjectConfig, ObjectState, required } from "src/utils/formState";

/**
 * The Import step's two fields.
 *
 * Both are `ID!`/`String!` on `CreateMaterialImportAiProposalInput`, but an unfilled field has to be
 * able to be empty, so the form holds them as nullable and `required` is what makes them mandatory.
 */
type MaterialImportFormValue = { itemId: Maybe<string>; manufacturerUrl: Maybe<string> };

export type MaterialImportFormState = ObjectState<MaterialImportFormValue>;

export const materialImportFormConfig: ObjectConfig<MaterialImportFormValue> = {
  itemId: { type: "value", rules: [required] },
  manufacturerUrl: { type: "value", rules: [required] },
};
